import { createContext, useContext, useState } from "react";

const dict = {
  it: {
    nav_home: "Home",
    nav_menu: "Menù",
    nav_gelateria: "Gelateria",
    nav_contacts: "Contatti",
    nav_call: "Chiama ora",
    home_cta_kicker: "Il menù completo",
    home_cta_title: "Oltre novanta pizze, i classici della casa e il gelato artigianale",
    home_cta_button: "Sfoglia il menù",
    hero_kicker: "Pizzeria · Ristorante · Gelateria — Paese, Treviso",
    hero_sub: "Pizza cotta a legna, cucina di mare e di terra, gelato artigianale fatto in casa. Sapori autentici, ingredienti selezionati.",
    hero_cta_menu: "Scopri il menù",
    hero_cta_gelato: "La gelateria",
    hero_scroll: "Scorri",
    marquee: ["Pizza cotta a legna", "Gelato artigianale", "Cucina veneta", "Consegna a domicilio", "Ingredienti selezionati"],
    chapters_kicker: "Le tre anime della casa",
    chapter_01_title: "La Pizzeria",
    chapter_01_text: "Impasto leggero, forno a legna e oltre novanta pizze in carta: dalle classiche alle speciali del pizzaiolo, fino alle nuove creazioni da provare.",
    chapter_02_title: "Il Ristorante",
    chapter_02_text: "I nostri classici: tegame del pescatore, spaghetti allo scogliera, paella, fritture e grigliate di pesce, tagliata di Angus. Cucina di mare e di terra, come una volta.",
    chapter_03_title: "La Gelateria",
    chapter_03_text: "Gelato artigianale fatto in casa, ogni giorno. Creme vellutate e sorbetti di frutta fresca, da gustare in cono o in coppetta.",
    chapter_cta_menu: "Vai al menù",
    chapter_cta_gelato: "Scopri i gusti",
    menu_kicker: "Dal nostro menù",
    menu_title: "Le Pizze",
    menu_note: "Tutte le pizze sono servite con origano. Fuori stagione il radicchio viene sostituito con le melanzane grigliate.",
    extras_title: "Extra / Variazioni",
    ristorante_title: "Il Ristorante — I Nostri Classici",
    ristorante_note: "* Tutte le fritture sono servite con verdurine fritte e polenta grigliata.",
    ristorante_nb: "Questi sono solo alcuni piatti del nostro menù: per il menù completo chiamaci.",
    gelato_page_kicker: "La Gelateria",
    gelato_page_title: "Artigianale, ogni giorno",
    gelato_page_text: "Il nostro gelato nasce in laboratorio ogni mattina: latte fresco, frutta di stagione e nient'altro. Questi sono alcuni dei gusti che trovi in vetrina — la selezione cambia con le stagioni.",
    gelato_flavors_title: "I Gusti",
    gelato_cta: "Vieni ad assaggiarlo",
    tag_classico: "Classico",
    tag_crema: "Creme",
    tag_frutta: "Frutta",
    "tag_della casa": "Della casa",
    contacts_kicker: "Ti aspettiamo",
    contacts_title: "Vieni a trovarci",
    contacts_delivery: "Consegna anche a domicilio",
    contacts_call: "Prenotazioni pranzo e cena",
    contacts_address_label: "Dove siamo",
    contacts_phone_label: "Telefono",
    contacts_route: "Indicazioni stradali",
    footer_note: "Pizzeria · Ristorante · Gelateria — Paese, Treviso",
  },
  en: {
    nav_home: "Home",
    nav_menu: "Menu",
    nav_gelateria: "Gelato",
    nav_contacts: "Contacts",
    nav_call: "Call now",
    home_cta_kicker: "The full menu",
    home_cta_title: "Over ninety pizzas, the house classics and artisanal gelato",
    home_cta_button: "Browse the menu",
    hero_kicker: "Pizzeria · Restaurant · Gelateria — Paese, Treviso",
    hero_sub: "Wood-fired pizza, seafood and land cuisine, homemade artisanal gelato. Authentic flavours, selected ingredients.",
    hero_cta_menu: "Explore the menu",
    hero_cta_gelato: "The gelateria",
    hero_scroll: "Scroll",
    marquee: ["Wood-fired pizza", "Artisanal gelato", "Venetian cuisine", "Home delivery", "Selected ingredients"],
    chapters_kicker: "The three souls of the house",
    chapter_01_title: "The Pizzeria",
    chapter_01_text: "Light dough, wood-fired oven and over ninety pizzas on the menu: from the classics to the pizzaiolo's specials, to brand-new creations.",
    chapter_02_title: "The Restaurant",
    chapter_02_text: "Our classics: fisherman's pan, seafood spaghetti, paella, fried and grilled fish, Angus steak. Sea and land cuisine, the traditional way.",
    chapter_03_title: "The Gelateria",
    chapter_03_text: "Homemade artisanal gelato, every single day. Velvety creams and fresh fruit sorbets, in a cone or a cup.",
    chapter_cta_menu: "See the menu",
    chapter_cta_gelato: "Discover flavours",
    menu_kicker: "From our menu",
    menu_title: "The Pizzas",
    menu_note: "All pizzas are served with oregano. Out of season, radicchio is replaced with grilled aubergines.",
    extras_title: "Extras / Variations",
    ristorante_title: "The Restaurant — Our Classics",
    ristorante_note: "* All fried dishes are served with fried vegetables and grilled polenta.",
    ristorante_nb: "These are just some of the dishes on our menu: call us for the full menu.",
    gelato_page_kicker: "The Gelateria",
    gelato_page_title: "Artisanal, every day",
    gelato_page_text: "Our gelato is made in our lab every morning: fresh milk, seasonal fruit and nothing else. These are some of the flavours in our display — the selection changes with the seasons.",
    gelato_flavors_title: "The Flavours",
    gelato_cta: "Come and taste it",
    tag_classico: "Classic",
    tag_crema: "Creams",
    tag_frutta: "Fruit",
    "tag_della casa": "House special",
    contacts_kicker: "We are waiting for you",
    contacts_title: "Come visit us",
    contacts_delivery: "Home delivery available",
    contacts_call: "Lunch and dinner reservations",
    contacts_address_label: "Where we are",
    contacts_phone_label: "Phone",
    contacts_route: "Get directions",
    footer_note: "Pizzeria · Restaurant · Gelateria — Paese, Treviso",
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = (key) => dict[lang][key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
